export default "__VITE_ASSET__Dyv7v9h___"